import { useEffect, useState } from 'react'
import { Smartphone, X } from 'lucide-react'
import './InstallAppButton.css'

// Knopka «Ustanovit» — svoya zamena brauzernoy plashki ustanovki PWA.
// Chrome kidaet beforeinstallprompt kogda sam reshit (i tolko odin raz za zagruzku),
// poetomu sobytie perehvatyvaem i derzhim u sebya: yuzer stavit prilozhenie togda,
// kogda emu nado, a ne kogda brauzer vspomnit.
export default function InstallAppButton() {
  const [deferred, setDeferred] = useState(null)
  const [installed, setInstalled] = useState(false)
  const [showHint, setShowHint] = useState(false)

  useEffect(() => {
    // Uzhe stoit kak prilozhenie — knopka ne nuzhna. iOS Safari vmesto display-mode
    // vystavlyaet navigator.standalone.
    const standalone = window.matchMedia?.('(display-mode: standalone)').matches
      || window.navigator.standalone === true
    if (standalone) setInstalled(true)

    const onPrompt = (e) => {
      e.preventDefault()   // gasim brauzernuyu plashku, stavim vmesto nee svoyu knopku
      setDeferred(e)
    }
    const onInstalled = () => { setInstalled(true); setDeferred(null); setShowHint(false) }

    window.addEventListener('beforeinstallprompt', onPrompt)
    window.addEventListener('appinstalled', onInstalled)
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt)
      window.removeEventListener('appinstalled', onInstalled)
    }
  }, [])

  if (installed) return null

  const handleClick = async () => {
    // Bez sohranennogo sobytiya postavit programmno nel'zya (iOS voobsche ego ne shlet,
    // Chrome ne shlet povtorno) — pokazyvaem, kuda nazhat rukami.
    if (!deferred) { setShowHint(v => !v); return }
    deferred.prompt()
    const { outcome } = await deferred.userChoice
    setDeferred(null)                       // sobytie odnorazovoe
    if (outcome !== 'accepted') setShowHint(true)
  }

  return (
    <div className="install-app-wrap">
      <button
        onClick={handleClick}
        className="btn btn-secondary btn-sm"
        title="Установить приложение на телефон"
      >
        <Smartphone size={14} /><span className="btn-label"> Установить</span>
      </button>

      {showHint && (
        <div className="install-hint" role="dialog">
          <button className="install-hint-close" onClick={() => setShowHint(false)} title="Закрыть">
            <X size={13} />
          </button>
          <div className="install-hint-title">Установить вручную</div>
          <div className="install-hint-row"><b>Android / Chrome:</b> меню ⋮ → «Установить приложение»</div>
          <div className="install-hint-row"><b>iPhone / Safari:</b> «Поделиться» → «На экран «Домой»»</div>
        </div>
      )}
    </div>
  )
}
